// Couleurs disponibles pour les marqueurs
export const MARKER_COLORS = [
  '#e74c3c',  // Rouge
  '#3498db',  // Bleu
  '#2ecc71',  // Vert
  '#f1c40f',  // Jaune
  '#9b59b6',  // Violet
  '#1abc9c',  // Turquoise
  '#e67e22',  // Orange
  '#34495e',  // Bleu foncé
  '#7f8c8d',  // Gris
  '#16a085',  // Vert foncé
  '#d35400',  // Orange foncé
  '#c0392b',  // Rouge foncé
  '#8e44ad',  // Violet foncé
  '#2980b9',  // Bleu royal
  '#27ae60',  // Vert forêt
] as const;

// Couleur par défaut pour les marqueurs
export const DEFAULT_MARKER_COLOR = '#3498db';  // Bleu

